import { useEffect, useState } from 'react';
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../app/store';
import { pages } from '../fakedata/pages';
import { selectTheme } from '../features/theme/themeSlice';
import '../scss/pages.scss';
const ShowPage = () => {
	const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
	const theme = useAppSelector(selectTheme);

	const { pagename } = useParams();
	const [htmlString, setHtmlString] = useState<string>('');
	useEffect(() => {
		const p = pages.filter(pg => pg.name === pagename);
		if (p.length > 0) {
			const l = p[0].laguages.filter(ln => ln.lang === theme.language);
			setHtmlString(l[0].html);
		} else {
			setHtmlString('');
		}
	}, [pagename]);

	return (
		<div className="page-wrapper">
			<div dangerouslySetInnerHTML={{ __html: htmlString }}></div>
		</div>
	);
};

export default ShowPage;
